import React from 'react';
//Impot State Data
import { InitStateData } from '../helpers/stateDataHelper'

//Context provides a way to pass BaseComponent data through the component tree without having to pass props down manually at every level.
const authContext = React.createContext({
    ...InitStateData()
});

export default authContext;